import { render, staticRenderFns } from "./view.vue?vue&type=template&id=776a90b6"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('776a90b6')) {
      api.createRecord('776a90b6', component.options)
    } else {
      api.reload('776a90b6', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=776a90b6", function () {
      api.rerender('776a90b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/entryDesign/view.vue"
export default component.exports